import * as React from "react";

import AppModals from "@editor/components/AppModals";
import { Loader } from "@editor/components/common/Loader";
import EmptyLayout from "@editor/components/layouts/EmptyLayout";
import useConnectShopifyIntegrationNavigator from "@editor/hooks/useConnectShopifyIntegrationNavigator";

const ShopifyPendingAppInstallationLayout = () => {
  useConnectShopifyIntegrationNavigator();

  return (
    <EmptyLayout>
      <Loader />
      <AppModals />
    </EmptyLayout>
  );
};

export default ShopifyPendingAppInstallationLayout;
